import { render, staticRenderFns } from "./CompGamificationModalStatesTapit.vue?vue&type=template&id=4a7726f8"
import script from "./CompGamificationModalStatesTapit.vue?vue&type=script&setup=true&lang=js"
export * from "./CompGamificationModalStatesTapit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports